import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "App";
import { VisionUIControllerProvider } from "context";

const root = createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <VisionUIControllerProvider>
      <App />
    </VisionUIControllerProvider>
  </HashRouter>
);
